"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoriesSectionProps = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
/* istanbul ignore file @preserve */

const categoriesSectionProps = exports.categoriesSectionProps = {
  categories: _editorialFetching.categories,
  title: 'Categories',
  viewButtonText: 'View'
};
